export class Account {
    AccountName: string;
    FullName: string;
    Password: string;
    Notes: string;
    PrivateNotes: string;
    AuthenticationProvider: string;
    ThirdPartyAuthenticationToken: string;
    ThirdPartyAuthenticationTokenExpirationDate: Date;
    Email: string;
    LoginFailedCount: number;
    PasswordNeverExpires: boolean;
    MustChangePassword: boolean;
    CannotChangePassword: boolean;
    PasswordExpirationDate: Date;
    PasswordDuration: number;
    Disabled: boolean;
    Locked: boolean;
    RegionalSettings: string;
    Language: string;
    WindowsAuthentication: boolean;
    ExpirationDate: Date;
    ParentAccount: string;
    Confirmed: boolean;
    CustomerId: number;
    LockTimer: Date;
    CreationDate: Date;
    NickName: string;
    TwoFactorType: number;
    MobilePhoneNr: string;
    MobilePhonePrefix: string;
    TOTPConfigured: boolean;
    CASUser: string;

    constructor() {}

    assign(account?: Account) {
        this.AccountName = account.AccountName;
        this.FullName = account.FullName;
        this.Password = account.Password;
        this.Notes = account.Notes;
        this.PrivateNotes = account.PrivateNotes;
        this.AuthenticationProvider = account.AuthenticationProvider;
        this.ThirdPartyAuthenticationToken = account.ThirdPartyAuthenticationToken;
        this.ThirdPartyAuthenticationTokenExpirationDate = account.ThirdPartyAuthenticationTokenExpirationDate;
        this.Email = account.Email;
        this.LoginFailedCount = account.LoginFailedCount;
        this.PasswordNeverExpires = account.PasswordNeverExpires;
        this.MustChangePassword = account.MustChangePassword;
        this.CannotChangePassword = account.CannotChangePassword;
        this.PasswordExpirationDate = account.PasswordExpirationDate;
        this.PasswordDuration = account.PasswordDuration;
        this.Disabled = account.Disabled;
        this.Locked = account.Locked;
        this.RegionalSettings = account.RegionalSettings;
        this.Language = account.Language;
        this.WindowsAuthentication = account.WindowsAuthentication;
        this.ExpirationDate = account.ExpirationDate;
        this.ParentAccount = account.ParentAccount;
        this.Confirmed = account.Confirmed;
        this.CustomerId = account.CustomerId;
        this.LockTimer = account.LockTimer;
        this.CreationDate = account.CreationDate;
        this.NickName = account.NickName;
        this.TwoFactorType = account.TwoFactorType;
        this.MobilePhoneNr = account.MobilePhoneNr;
        this.MobilePhonePrefix = account.MobilePhonePrefix;
        this.TOTPConfigured = account.TOTPConfigured;
        this.CASUser = account.CASUser;
    }
}

export class AccountData {
    NickName: string;
    AccountName: string;
    ParentAccount: string;
    Roles: string;
    isEditable: boolean;
    CreationDate: Date;
    ExpirationDate: Date;
    associationHasExpired: boolean;
    IsClicked: boolean;
    willExpireIn100: boolean;
    ArrayRoles: string[];
    TwoFactorType: number;
    MobilePhoneNr: string;
    MobilePhonePrefix: string;
    CasUser: string;
    ShowAdministrativeRoles: boolean;
    ShowApplicationeRoles: boolean;
}
